<label class="form-zone-label">Rattachement automatique</label>

<form [formGroup]="autoLinkForm" novalidate class="container">
    <div class="form-item form-item-linkAttribute form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Attribut utilisé pour le rattachement</mat-label>
            <mat-select data-select-attributeId formControlName="linkAttribute" tabindex="1" (selectionChange)="onLinkAttributeChanged($event)" required>
                @for (attribute of _context.attributes; track attribute) {
                    <mat-option data-select-listing-attribute-option [value]="attribute.id">
                        {{ attribute.header }}
                    </mat-option>
                }
            </mat-select>
            @if (autoLinkForm.get('linkAttribute')?.errors?.required && (autoLinkForm.get('linkAttribute')?.dirty || autoLinkForm.get('linkAttribute').touched)) {
                <mat-error>Le champ 'Attribut utilisé pour le rattachement' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon
            [icon]="faCircleInfo"
            class="info-icon"
            hubToolTip="Ce paramètre permet de specifier l'attribut qui sera utilisé pour réaliser le rattachement. Le système va rechercher le dossier existant dont la valeur de cet attribut est égale à la valeur du groupe de capture de l'expression régulière.<br>Si un dossier existe, alors le mail reçu est ajouté en tant que document mail au dossier existant."
            tooltipPosition="right"></fa-icon>
    </div>

    <div class="form-item form-item-allowedStates form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>États du dossier cible autorisés pour le rattachement</mat-label>
            <mat-select data-select-allowedStates formControlName="allowedStates" multiple tabindex="2" (selectionChange)="onAllowStatesChanged($event)" required>
                @for (folderState of _context.folderStates; track folderState) {
                    <mat-option data-select-listing-allowedState-option [value]="folderState.id">
                        {{ folderState.name }}
                    </mat-option>
                }
            </mat-select>
            @if (autoLinkForm.get('allowedStates')?.errors?.required && (autoLinkForm.get('allowedStates')?.dirty || autoLinkForm.get('allowedStates').touched)) {
                <mat-error>Le champ 'États du dossier cible autorisés pour le rattachement' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon
            [icon]="faCircleInfo"
            class="info-icon"
            hubToolTip="Ce paramètre permet de limiter la recherche d'un dossier existant à certains états. Si un dossier de rattachement existe mais qu'il ne se trouve pas dans un des états spécifiés, le système réagira comme si le dossier n'existait pas."
            tooltipPosition="right"></fa-icon>
    </div>

    <div class="form-item form-item-postLinkState form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>États du dossier après le rattachement</mat-label>
            <mat-select data-select-postLinkState formControlName="postLinkState" tabindex="3" (selectionChange)="onPostLinkStateChanged($event)">
                <mat-option data-select-listing-postLinkState-option [value]="-1">Inchangé</mat-option>
                @for (folderState of _context.folderStates; track folderState) {
                    <mat-option data-select-listing-postLinkState-option [value]="folderState.id">
                        {{ folderState.name }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <fa-icon
            [icon]="faCircleInfo"
            class="info-icon"
            hubToolTip="Ce paramètre permet de définir dans quel état passera le dossier cible après le rattachement du mail reçu."
            tooltipPosition="right"></fa-icon>
    </div>

    <div class="form-item form-item-failAction form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Action en cas d'erreur de rattachement</mat-label>
            <mat-select data-select-failAction formControlName="failAction" tabindex="4" (selectionChange)="onFailActionChanged($event)" required>
                @for (action of actions; track action) {
                    <mat-option data-select-listing-failAction-option [value]="action.value">
                        {{ action.text }}
                    </mat-option>
                }
            </mat-select>
            @if (autoLinkForm.get('failAction')?.errors?.required && (autoLinkForm.get('failAction')?.dirty || autoLinkForm.get('failAction').touched)) {
                <mat-error>Le champ 'Action en cas d'erreur de rattachement' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon
            [icon]="faCircleInfo"
            class="info-icon"
            hubToolTip="Ce paramètre permet de définir ce qu'il advient du mail reçu si aucun dossier de rattachement n'est trouvé.
        <ul><li><b>Création d'un nouveau dossier</b> : Un nouveau dossier est créé avec le document reçu.</li><li><b>Redirection vers la bannette de rejet</b> : Le document est redirigé vers une bannette de rejt</li></ul><br>La seconde option n'est pas implémentée."
            tooltipPosition="right"></fa-icon>
    </div>

    <div class="form-item form-item-overridedAttributes form-item-help">
        <div class="override-table-container">
            <app-attribute-override-table
                formControlName="attributesOverride"
                [attributes]="_context.attributes"
                ngDefaultControl
                (attributesChanged)="onAttributesChanged($event)"></app-attribute-override-table>
        </div>
    </div>
</form>
